import React from 'react';
import Swal from "sweetalert2";
import { Field, Form } from 'react-final-form';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const InstrumentsList = (props) => {
    const submitInstrumentUpdates = (instrument) => {
        AdminInterface.instance.updateInstrument(instrument).then(() => {
            Swal.fire('Updated!', '', 'success')
            props.setListRequiresReload(true);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: [error.response?.data?.detail.map((detail) => detail.msg)],
            });
        })
    }

    return (
        <Card>
            <CardBody>
                <CardTitleWrap>
                    <CardTitle>Edit Instrument</CardTitle>
                </CardTitleWrap>
                <Form onSubmit={submitInstrumentUpdates} initialValues={props.selectedInstrument}>
                    {({ handleSubmit, form }) => (
                        <FormContainer horizontal onSubmit={handleSubmit}>
                            <FormGroup>
                                <FormGroupLabel>Name</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="name" component="input" type="text" placeholder="Name" />
                                </FormGroupField>
                            </FormGroup>
                            <FormButtonToolbar>
                                <Button variant="primary" type="submit">Submit</Button>
                                <Button variant="secondary" type="button" onClick={() => props.setSelectedInstrument(null)}>
                                    Cancel
                                </Button>
                            </FormButtonToolbar>
                        </FormContainer>
                    )}
                </Form>
            </CardBody>
        </Card>
    );
};

export default InstrumentsList;